<template>
  <div>
    <list-courses @update="update" @create="create()" @remove="remove" />
    <form-gestion :modal="modal" :external-action="evento" @close="close" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import formGestion from './FormManager'
import listCourses from './List'

export default {
  name: 'Dashboard',
  components: {
    listCourses,
    formGestion,
  },
  /**
   * Este componente solo tiene dos variables:
   * evento -> controla el evento actual en curso (create,
   * @returns {{evento: string, modal: boolean}}
   */
  data() {
    return {
      modal: false,
      evento: '',
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      clear: 'courses/setClearOne',
      init: 'courses/setInit',
      setStatus: 'events/setStatus',
      teamsInit: 'teams/fetchList',
      fetchUsers: 'users/fetchList',
      tournamentInit: 'tournaments/fetchList',
    }),
    create() {
      this.modal = true
      this.evento = 'create'
    },
    update() {
      this.modal = true
      this.evento = 'update'
    },
    remove() {
      this.modal = true
      this.evento = 'delete'
    },
    close() {
      this.evento = ''
      this.modal = false
      this.clear()
    },
    async initData() {
      // this.resetPagitations()
      await Promise.all([
        this.init(),
        this.fetchLanguages(),
        this.teamsInit(),
        this.fetchUsers(),
        this.tournamentInit(),
      ])
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
  },
}
</script>
